import { render, staticRenderFns } from "./vitalPro_xf.vue?vue&type=template&id=4c34986e&scoped=true&"
import script from "./vitalPro_xf.vue?vue&type=script&lang=js&"
export * from "./vitalPro_xf.vue?vue&type=script&lang=js&"
import style0 from "./vitalPro_xf.vue?vue&type=style&index=0&id=4c34986e&scoped=true&lang=css&"
import style1 from "./vitalPro_xf.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34986e",
  null
  
)

export default component.exports